import React from "react";
import { connect } from "react-redux";
import moment, { utc } from "moment";
import { startCase } from "lodash";
import { deviceConstants } from "../../modules/devices";
import Datatable from "../Datatable";
import Truncated from "../Truncated";
import Config from "../../config";
import Icon from "../Icon";
import TestActionButton from "./TestActionButton";
import TestOptionsMenu from "./TestOptionsMenu";
import { STATUS, STATUS_LABELS } from "../../modules/wevos/constants";
import CircularProgress from "material-ui-old/CircularProgress";
import { isLoading, PROGRESS } from "../../modules/asyncHttpAction";
import * as dashboard from "../../modules/dashboard";
import * as styles from "../../styles/components/DashboardTable.css";

const getHumanTime = timestamp => {
    return utc(timestamp)
        .local()
        .format("MM-DD-YYYY h:mma");
};
const getElapsedTime = (start, end) => {
    const t1 = moment(start);
    const t2 = moment(end);
    const duration = moment.duration(t2.diff(t1));
    const ms = duration.asMilliseconds();
    return utc(ms).format("D[d], H[h], m[m]");
};

function TestNameCell({ wevo }) {
    return (
        <Truncated
            type="div"
            maxLength={Config.test().testNameTruncateLength}
            className={styles.testNameCell}
        >
            {wevo.name}
        </Truncated>
    );
}

function LastUpdatedCell({ wevo }) {
    return (
        <div className={styles.lastUpdatedCell}>
            {getHumanTime(wevo.dateModified)}
        </div>
    );
}

function DeviceIcon({ device }) {
    return (
        <div className={styles.deviceIcon}>
            {React.createElement(device.icon)}
        </div>
    );
}

function DeviceCell({ wevo }) {
    const { DEVICES } = deviceConstants;
    return (
        <div className={styles.deviceIconContainer}>
            {wevo.devices.map(({ id }) => (
                <DeviceIcon key={id} device={DEVICES[id]} />
            ))}
        </div>
    );
}

function StatusCell({ wevo }) {
    let caption;
    const label = STATUS_LABELS[wevo.status];

    if (wevo.status === STATUS.completed) {
        caption = `Completed  ${getElapsedTime(
            wevo.datePublished,
            wevo.dateCompleted
        )}`;
    }

    const classNames = [styles.statusCell, styles[wevo.status]];
    return (
        <div>
            <div className={classNames.join(" ")}>{label}</div>
            <div className={styles.cellCaption}>{caption}</div>
        </div>
    );
}

function ActionsCell({ wevo }) {
    return (
        <div id="action-cell" className={styles.actionsCell}>
            <TestActionButton wevo={wevo} />
            <TestOptionsMenu wevo={wevo} containerId="action-cell" />
        </div>
    );
}

function DashboardTable({ wevos, listWevosRequest }) {
    const columns = [
        Datatable.createColumn({
            renderHeaderCell: () => <h5>Test Name</h5>,
            renderBodyCell: wevo => <TestNameCell wevo={wevo} />,
            cellWidthPercentage: 30,
            comparator: "name"
        }),
        Datatable.createColumn({
            renderHeaderCell: () => <h5>Device</h5>,
            renderBodyCell: wevo => <DeviceCell wevo={wevo} />,
            cellWidthPercentage: 20,
            comparator: "devices"
        }),
        Datatable.createColumn({
            renderHeaderCell: () => <h5>Updated</h5>,
            renderBodyCell: wevo => <LastUpdatedCell wevo={wevo} />,
            cellWidthPercentage: 20,
            comparator: "dateModified"
        }),
        Datatable.createColumn({
            renderHeaderCell: () => <h5>Status</h5>,
            renderBodyCell: wevo => <StatusCell wevo={wevo} />,
            cellWidthPercentage: 15,
            comparator: "status"
        }),
        Datatable.createColumn({
            renderHeaderCell: () => <h5> </h5>,
            renderBodyCell: wevo => <ActionsCell wevo={wevo} />,
            cellWidthPercentage: 15
        })
    ];

    return (
        <Datatable
            data={wevos}
            columns={columns}
            scroll={{ height: "calc(100% - 10.4rem)" }}
            className={styles.dashboardTable}
            style={{ width: "100%", margin: "auto", paddingBottom: "2rem" }}
            headerCell={styles.headerCell}
            rowCell={styles.rowCell}
        >
            {isLoading(listWevosRequest) && (
                <div className={styles.nonIdeal}>
                    <CircularProgress />
                </div>
            )}
            {listWevosRequest === PROGRESS.success &&
                wevos.length === 0 && (
                    <p id="no-data-message" className={styles.noDataMessage}>
                        No wevos available.
                    </p>
                )}
        </Datatable>
    );
}

function mapStateToProps(state, props) {
    const { listWevosRequest } = state.dashboard;
    const wevos = dashboard.getFilteredWevos(state, props);

    return {
        wevos,
        listWevosRequest
    };
}

export default connect(
    mapStateToProps,
    null
)(DashboardTable);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable.js